//medidad Banner 650x360px
export const ultimasNoticias = [
   {
        "imagen" :"https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/dmt.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/6.-convocatoria DMT.pdf",
        "titulo" : "DÍA MUNDIAL del TEATRO 2026",
        "fecha" : "del 24 de febrero al 07 de marzo del 2026"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Maraton Nacional de Teatro.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/5.-Convocatoria 18 Gran Maratón Nacional de Teatro.pdf",
        "titulo" : "Convocatoria Gran Maratón Nacional de Teatro para Niñas, Niños, Niñes y Adolescentes ",
        "fecha" : "del 16 de febrero al 26 de febrero"
    },  
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Banda Sinfónica.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/4.Convocatoria banda.pdf",
        "titulo" : "Convocatoria Banda Sinfónica del Centro de las Artes",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Coro.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/3.Convocatoria Coro Niñas y Niños Cantores de Hidalgo 2026.pdf",
        "titulo" : "Convocatoria Coro de Niñas y Niños Cantores de Hidalgo",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },
      {
        "imagen" :"../assets/imgs/Convocatorias/2026/Orquesta Sinfónica.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/2.Convocatoria orquesta.pdf",
        "titulo" : "Convocatoria Orquesta Sinfónica Infantil y Juvenil del Centro de las Artes de Hidalgo",
        "fecha" : "del 03 de febrero al 28 de febrero del 2026"
    },

]